import { render, staticRenderFns } from "./MessageTab.vue?vue&type=template&id=eaf55abc&"
import script from "./MessageTab.vue?vue&type=script&lang=ts&"
export * from "./MessageTab.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports